'use strict'

import { apiInstance, legacyV3 } from './index'
import { mapArgs } from 'utils/functions'

const firstAccess = {
  getCompanyNameFirstAccess (employeeId, ...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV3()}/employee/${employeeId}/firstAccess`,
      params
    })
  },

  setEmployeeDataFirstAccess (employeeId, data) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV3()}/employee/${employeeId}/firstAccess`,
      data
    })
  }
}

export default firstAccess
